import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import Spinner from '@atlaskit/spinner';

import { messages } from '../messages';

const loadingCss = css({
	alignItems: 'center',
	display: 'flex',
	justifyContent: 'center',
	minHeight: '100vh',
});

export const LoadingSpinner = () => {
	const intl = useIntl();
	return (
		<div css={loadingCss} role="progressbar" aria-label={intl.formatMessage(messages.loading)}>
			<Spinner size="large" />
		</div>
	);
};
